import type { SimulatorAppDefinition, SimulatorCommandInput, SimulatorCommandResult, SimulatorLaunchSource, SimulatorProfileDefinition } from "../contracts/appManifest.js";
import type { ShellCommandLogEntry } from "../state/shellState.js";
import { CalculatorApp } from "./calculator/CalculatorApp.js";
import { CloudAdminApp } from "./cloud-admin/CloudAdminApp.js";
import { DhcpManagerApp } from "./dhcp-manager/DhcpManagerApp.js";
import { DirectoryUsersComputersApp } from "./directory-users-computers/DirectoryUsersComputersApp.js";
import { DnsManagerApp } from "./dns-manager/DnsManagerApp.js";
import { EventViewerApp } from "./event-viewer/EventViewerApp.js";
import { ExplorerApp } from "./explorer/ExplorerApp.js";
import { FirewallConsoleApp } from "./firewall-console/FirewallConsoleApp.js";
import { GenericApp } from "./generic/GenericApp.js";
import { GroupPolicyApp } from "./group-policy/GroupPolicyApp.js";
import { LocalUsersGroupsApp } from "./local-users-groups/LocalUsersGroupsApp.js";
import { NetworkConnectionsApp } from "./network-connections/NetworkConnectionsApp.js";
import { NotepadApp } from "./notepad/NotepadApp.js";
import { PaintApp } from "./paint/PaintApp.js";
import { PrintersApp } from "./printers/PrintersApp.js";
import { RemoteAccessApp } from "./remote-access/RemoteAccessApp.js";
import { ServerManagerApp } from "./server-manager/ServerManagerApp.js";
import { ServicesApp } from "./services/ServicesApp.js";
import { SettingsApp } from "./settings/SettingsApp.js";
import { SystemPropertiesApp } from "./system-properties/SystemPropertiesApp.js";
import { TaskManagerApp } from "./task-manager/TaskManagerApp.js";
import { TaskSchedulerApp } from "./task-scheduler/TaskSchedulerApp.js";
import { TerminalApp } from "./terminal/TerminalApp.js";

export interface SimulatorAppSurfaceProps {
  activeMachine: string;
  app: SimulatorAppDefinition;
  commandLog: ShellCommandLogEntry[];
  onOpenApp: (appId: string, source: SimulatorLaunchSource, meta?: Record<string, unknown>) => void;
  onRunAlias: (command: string, source: SimulatorLaunchSource) => boolean;
  onRunCommand: (input: SimulatorCommandInput) => Promise<SimulatorCommandResult>;
  profile: SimulatorProfileDefinition;
}

export function AppSurface(props: SimulatorAppSurfaceProps) {
  if (props.app.kind === "calculator") {
    return <CalculatorApp {...props} />;
  }

  if (props.app.kind === "cloud-admin") {
    return <CloudAdminApp {...props} />;
  }

  if (props.app.kind === "dhcp-manager") {
    return <DhcpManagerApp {...props} />;
  }

  if (props.app.kind === "directory-users-computers") {
    return <DirectoryUsersComputersApp {...props} />;
  }

  if (props.app.kind === "dns-manager") {
    return <DnsManagerApp {...props} />;
  }

  if (props.app.kind === "event-viewer") {
    return <EventViewerApp {...props} />;
  }

  if (props.app.kind === "explorer") {
    return <ExplorerApp {...props} />;
  }

  if (props.app.kind === "firewall-console") {
    return <FirewallConsoleApp {...props} />;
  }

  if (props.app.kind === "group-policy") {
    return <GroupPolicyApp {...props} />;
  }

  if (props.app.kind === "settings") {
    return <SettingsApp {...props} />;
  }

  if (props.app.kind === "terminal") {
    return <TerminalApp {...props} />;
  }

  if (props.app.kind === "local-users-groups") {
    return <LocalUsersGroupsApp {...props} />;
  }

  if (props.app.kind === "network-connections") {
    return <NetworkConnectionsApp {...props} />;
  }

  if (props.app.kind === "notepad") {
    return <NotepadApp {...props} />;
  }

  if (props.app.kind === "paint") {
    return <PaintApp {...props} />;
  }

  if (props.app.kind === "printers") {
    return <PrintersApp {...props} />;
  }

  if (props.app.kind === "remote-access") {
    return <RemoteAccessApp {...props} />;
  }

  if (props.app.kind === "server-manager") {
    return <ServerManagerApp {...props} />;
  }

  if (props.app.kind === "services") {
    return <ServicesApp {...props} />;
  }

  if (props.app.kind === "system-properties") {
    return <SystemPropertiesApp {...props} />;
  }

  if (props.app.kind === "task-manager") {
    return <TaskManagerApp {...props} />;
  }

  if (props.app.kind === "task-scheduler") {
    return <TaskSchedulerApp {...props} />;
  }

  return <GenericApp {...props} />;
}
